// @flow
import { fetch } from '../../../api';
import { fetchData } from '../dataActionsCreator';

export default (id: IdType, groupCode: string) => {
  const fetchFunction = async () => {
    const { payload } = await fetch(
      'post/' + id,
      { query: { groupCode, isDraft: false, id } },
    );
    const { users, ratings, post, userRatings, isFollowing } = payload;

    return { users, ratings, userRatings, posts: [{ ...post, isFollowing }] };
  };

  return fetchData(fetchFunction);
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/posts/fetch.js